import React, { useState, useEffect, useCallback } from "react"
import { Spinner, Table, Button } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import "./enrolmentTable.css"
import {
  fetchEnrolsAction,
  fetchEnrolsByLocationAction,
} from "../../pages/enrolment/enrolmentAction"
import { NoData } from "../no-data/NoData"
import { compareAsc } from "date-fns"
import { fetchCoursesAction } from "../../pages/course/courseAction"

export const EnrolmentTable = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)
  const [shouldFetch, setShouldFetch] = useState(true)
  const [enrolments, setEnrolments] = useState([])
  const [crs, setCrs] = useState([])
  const [filterVal, setFilterVal] = useState("")
  const { isLoading, enrollments } = useSelector((state) => state.enroll)
  const { courses } = useSelector((state) => state.course)

  useEffect(() => {
    const params = new URLSearchParams()
    params.set("branch", user?.branch)
    !courses.length && dispatch(fetchCoursesAction(params.toString()))
    courses.length && setCrs(courses)
  }, [courses, dispatch, user?.branch])

  const onSearch = (str) => {
    const { value } = str.target
    const newArray = enrollments?.filter((e) =>
      (e.fName.toLowerCase() + " " + e.lName.toLowerCase()).includes(
        value.toLowerCase()
      )
    )
    setEnrolments(newArray)
  }

  const handleFilter = (e) => {
    const value = e.target.value
    setFilterVal(value)
    localStorage.setItem("filter", value)
    updateList(value)
  }

  const updateList = useCallback(
    (fl) => {
      const filter = fl || localStorage.getItem("filter")

      filter === "All" || !filter
        ? setEnrolments(enrollments)
        : setEnrolments(enrollments.filter((e) => e.course.courseCode === fl))
    },
    [enrollments]
  )

  useEffect(() => {
    if (user?.branch) {
      const params = new URLSearchParams()
      params.set("branch", user?.branch)
      shouldFetch && dispatch(fetchEnrolsAction(params))
      setShouldFetch(false)
      setFilterVal(localStorage.getItem("filter"))
      enrollments.length && updateList(localStorage.getItem("filter"))
    }
  }, [dispatch, enrollments.length, user?.branch, updateList, shouldFetch])

  if (isLoading) {
    return <Spinner animation="border" variant="primary" />
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div className="">{enrolments?.length} Enrollments found!</div>
        <div className="search-container">
          <label htmlFor="searchForm">
            <input
              type="search"
              name="searchForm"
              id="searchInpout"
              className="searchInput"
              placeholder="Search name..."
              onChange={onSearch}
            />
          </label>
        </div>

        <div className="my-3 d-flex gap-4">
          <div
            className="refreshList"
            onClick={() =>
              dispatch(fetchEnrolsByLocationAction(`branch=${user.branch}`))
            }
          >
            <i className="fas fa-redo"></i>
          </div>
          <select
            name="batch"
            onChange={handleFilter}
            className="px-2"
            value={filterVal}
          >
            <option value="All">All</option>
            {crs?.map((c) => (
              <option
                key={c._id}
                value={c.courseCode}
                defaultValue={c.courseCode === localStorage.getItem("filter")}
              >
                {c.courseCode}
              </option>
            ))}
          </select>
        </div>
      </div>

      {!enrolments.length ? (
        <NoData />
      ) : (
        <div className="table-responsive">
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>Progress</th>
                <th>Name</th>
                <th>Course Name</th>
                <th>Location</th>
                <th>Fees Payment</th>
                <th>Due Date</th>
                {/* <th>Total Fees</th> */}
                <th>Code</th>
                {/* <th>Discounted Fee</th> */}
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              {enrolments.map((enroll, index) => (
                <tr key={enroll._id}>
                  <td>{index + 1}</td>
                  <td
                    className={
                      enroll?.progress === "cancelled"
                        ? "text-danger"
                        : enroll?.progress === "complete"
                        ? "text-success"
                        : "text-info"
                    }
                  >
                    {enroll?.progress.toUpperCase()}
                  </td>
                  <td>{`${enroll.fName} ${enroll.lName}`}</td>
                  <td>{enroll?.course?.name}</td>
                  <td>{enroll?.location}</td>
                  <td
                    className={
                      (enroll?.payment?.status === "paid" && "text-success") ||
                      (compareAsc(
                        new Date(),
                        new Date(enroll?.payment?.dueDate)
                      ) === -1
                        ? "text-warning"
                        : "text-danger")
                    }
                  >
                    {compareAsc(
                      new Date(),
                      new Date(enroll?.payment?.dueDate)
                    ) === -1 ? (
                      enroll?.payment?.status.toUpperCase()
                    ) : enroll?.payment?.dueDate === null ? (
                      <span className="text-success">NO OVERDUE</span>
                    ) : (
                      "Overdue".toUpperCase()
                    )}
                  </td>
                  <td>
                    {enroll?.payment?.dueDate
                      ? new Date(enroll?.payment?.dueDate).toLocaleDateString()
                      : "---"}
                  </td>
                  {/* <td>${enroll?.fees?.originalFee} </td> */}
                  <td>{enroll?.referralCode ? enroll.referralCode : "N/A"} </td>
                  {/* <td>${enroll?.fees?.discountedFee} </td> */}
                  <td>
                    <Link to={`/enrolInfo/${enroll._id}`}>
                      <Button variant="success">Info</Button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  )
}
